import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SlideDTO } from '@app/model/slideDTO.model';
import { NavigateService } from '@app/services/navigate.service';
import { NodeModel } from 'library-explorer';

@Component({
    selector: 'app-slide-carousel',
    templateUrl: './slide-carousel.component.html',
    styleUrls: ['./slide-carousel.component.scss'],
    standalone: false
})
export class SlideCarouselComponent implements OnInit {
  @Input() public data: Partial<SlideDTO>;

  @Output() public interactionCompleted = new EventEmitter<number>();

  private completedSlides: boolean[] = [];

  constructor(private readonly navigateService: NavigateService) { }

  ngOnInit(): void {
    this.completedSlides = new Array(this.data.carouselSlides?.length).fill(false);
  }

  public slideViewed(index: number): void {
    this.completedSlides[index] = true;

    const completedLength = this.completedSlides.filter(item => item === true).length;

    this.interactionCompleted.emit(completedLength / this.data.carouselSlides?.length);
  }

  public navigateToContent(node: NodeModel): void {
    if (!node) {
      return;
    }
  
    this.navigateService.navigateToEntity(node);
  }
}
